// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditableDateCell .DateInput {
  padding-right: 0 !important;
  padding-left: 0 !important;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/common/Table/cells/EditableDateCell/styles.scss"],"names":[],"mappings":"AACE;EACE,2BAAA;EACA,0BAAA;EACA,kBAAA;AAAJ","sourcesContent":[".EditableDateCell {\n  .DateInput {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
